import { createFileRoute } from "@tanstack/react-router";
import Page from "@/pages/Forms";
import { pageHead } from "@/lib/seo";

export const Route = createFileRoute("/forms")({
  head: () => pageHead({ title: "Formulários | Clara Camille", path: "/forms", noindex: true }),
  component: Page,
});
